import React, { useEffect, useState } from 'react';
import { getBacchusURL, remainingTime } from '../shared/Functions';
import { authProvider } from '../../services/Security';

export const AutoPay = ({district, errorToast}) => {
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const url = getBacchusURL()

    useEffect(() => {
        if(!district) return;
        loadIframe()
        setResetToken(false)
    }, [resetToken, district])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = () => {
        setCount(count+1)
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(true), remainingTime(token.tokenExpires))
            const frame = document.getElementById('autoPay') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                districtId: district?.id
            }), url);
        })
    }

    return (
        <React.Fragment>
            <iframe id="autoPay"
                title="autoPay"
                src={`${url}/#/app/autopay`}
                width="1600px"
                height="1100px"
                onLoad={() => count > 1 ? null : loadIframe()}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
        </React.Fragment>
    );
}
